import { useState, useEffect } from 'react';

const MOBILE_SIZE = 375;

export const useIsMobile = (): boolean => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= MOBILE_SIZE);
  const handleResize = () => {
    setIsMobile(window.innerWidth <= MOBILE_SIZE);
  };

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return isMobile;
};
